import { Component, Input, OnChanges, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AlertPanelModel } from "../_models/common/alertPanelModel";
import { ButtonConfig } from "../shared/design-system/button/button.modal";
import { ButtonComponent } from "../shared/design-system/button/button.component";
import { ModalComponent } from "../shared/design-system/modal/modal.component";
import { ModalConfig } from "../shared/design-system/modal/modal.modal";
import { PanelComponent } from "../shared/design-system/panel/panel.component";
import { PanelConfig } from "../shared/design-system/panel/panel.modal";
import { TranslateService } from "@ngx-translate/core";
import { ICONS } from "../_helpers/icons.constants";

@Component({
    selector: "app-alert-new-panel",
    templateUrl: "./alert-new-panel.component.html",
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonComponent, ModalComponent, PanelComponent]
})
export class AlertNewPanelComponent implements OnChanges {
  @Input() data: AlertPanelModel;
  @Input() isConfirmDisplay: boolean = true;
  @Output() callbackEvent = new EventEmitter<any>();
  hideInfoIcon: boolean = false;
  singleMessageTextClass: string = "";
  ICONS = ICONS;

  alertModalOneConfig: ModalConfig = {
    size: 'md',
    variant: 'default',
    hiddenCloseIcon: false,
    visible: false
  };

  alertPanelConfig: PanelConfig = {
      id: 'alert-panel',
      title: this.translate.instant('label_alert'),
      size: 'md',
      position: 'right',
      hasOverlay: true,
      isVideo: false
    };

  dismissButtonConfig: ButtonConfig = { label: '', color: 'primary', size: 'md' };
  acceptButtonConfig: ButtonConfig = { label: '', color: 'danger', size: 'md' };
  fixButtonConfig: ButtonConfig = { label: '', color: 'primary', size: 'lg' };
  continueButtonConfig: ButtonConfig = { label: '', color: 'primary', size: 'md' };

  /**
   * Whether every row in the checklist came back Mapped.
   *
   * The summary banner sits outside the `@for` that renders those rows, so it cannot test a
   * single `item` - it has to ask about the set. Empty counts as NOT all-mapped: with no rows
   * there is nothing to report success about, and the banner keeps its neutral warning form.
   */
  get isAllFieldsMapped(): boolean {
    return !!this.data?.fields?.length && this.data.fields.every(field => field.status === 'Mapped');
  }

  constructor(private sanitizer: DomSanitizer, private translate: TranslateService) {
  }

  ngOnChanges(): void {
    if (!this.data) {
      return;
    }

    if (this.data.hideInfoIcon) {
      this.hideInfoIcon = this.data.hideInfoIcon;
    }
    if (this.data.singleMessagetextClass) {
      this.singleMessageTextClass = this.data.singleMessagetextClass;
    }

    this.data.varient == "default"? this.alertModalOneConfig = {
      ...this.alertModalOneConfig,
      title: this.data.title,
      visible: !!this.data.showPanel,
      variant: 'default',
      headerIconSrc: this.data.headerIcon || ICONS.FILE
    }:
    this.alertModalOneConfig = {
      ...this.alertModalOneConfig,
      title: this.data.title,
      visible: !!this.data.showPanel,
      variant: 'error',
      headerIconSrc: this.data.headerIcon || null
    }; 

    this.dismissButtonConfig = {
      label: this.data.btnCancelToolTipText,
      color: 'primary-outline',
      size: 'md'
    };
    
    this.fixButtonConfig = { label: this.data.btnCancelToolTipText, color: 'primary', size: 'md' };
    this.data.varient == "default"? 
    this.acceptButtonConfig = {
      label: this.data.btnOkToolTipText,
      color: 'primary',
      size: 'md'
    }:
    this.acceptButtonConfig = {
      label: this.data.btnOkToolTipText,
      color: 'danger',
      size: 'md'
    };
     this.continueButtonConfig = {
      label: this.data.btnOkToolTipText,
      color: 'primary',
      size: 'lg'
    };
    this.alertPanelConfig = {...this.alertPanelConfig,
      title: this.translate.instant('label_alert'),
    };
  }

  getButtonConfig(item: any): ButtonConfig {
    return {
      label: item.btnText,
      color: item.btnClass && item.btnClass.includes('outline') ? 'primary-outline' : 'primary',
      size: 'md'
    };
  }

  accept() {
    this.callbackEvent.emit(true);
  }

  dismiss() {
    this.callbackEvent.emit(false);
  }

  sanitizerHtml(element) {
    let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
    return safeText;
  }

  fnSendAction(action: number) {
    this.callbackEvent.emit(action);
  }

}
